import React, { useState } from "react";
import { useWallet } from "../context/walletContext";
import { formatAmount } from "../utils/formatAmount";
import { TransferAepsToMainWallet } from "../api/aepsApi";
import { useNotify } from "../context/NotifyContext"; // ✅ notify

const AepsToMain = ({ aeps, close }) => {
  const {notify} = useNotify();
  const { walletAmt } = useWallet();
  const [amountToMove, setAmountToMove] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Full Validations
    if (!walletAmt?.aeps?.balance || walletAmt.aeps.balance <= 0) {
      return notify("No Balance in AEPS Wallet", "error");
    }

    if (!amountToMove || Number(amountToMove) <= 0) {
      return notify("Enter a valid amount to move", "warning");
    }

    if (Number(amountToMove) > walletAmt.aeps.balance) {
      return notify("Amount exceeds AEPS wallet balance", "error");
    }

    if (!remarks.trim()) {
      return notify("Remarks are required", "warning");
    }

    const payload = {
      amount: Number(amountToMove),
      remarks: remarks.trim(),
    };

    try {
      setLoading(true);
      const res = await TransferAepsToMainWallet(payload);

      if (res.success) {
        notify(res.message || "Amount transferred to Main Wallet", "success");
        close();

        // ✅ Reset form
        setAmountToMove("");
        setRemarks("");
      } else {
        notify(res.message || "Transfer Failed", "error");
      }
    } catch (err) {
      notify(err.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!aeps) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div
        className="ds-modal w-[90%] max-w-sm z-[10000] max-h-[90vh] overflow-y-auto ds-scroll"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-base font-semibold text-[var(--text-dark)]">
            AEPS to Main Wallet Transfer
          </h2>
          <button type="button" onClick={close} className="text-[var(--text-muted)] hover:text-[var(--text-dark)] text-lg">
            ×
          </button>
        </div>

        <form className="space-y-2" onSubmit={handleSubmit}>
          <div>
            <label className="ds-label">
              Available Balance In AEPS Wallet
            </label>
            <input
              type="text"
              value={formatAmount(walletAmt?.aeps?.balance)}
              disabled
              className="ds-input text-sm bg-[var(--bg-app)] cursor-not-allowed"
            />
          </div>

          <div>
            <label className="ds-label">
              Movable Balance
            </label>
            <input
              type="text"
              value={formatAmount(walletAmt?.aeps?.balance)}
              disabled
              className="ds-input text-sm bg-[var(--bg-app)] cursor-not-allowed"
            />
          </div>

          <div>
            <label className="ds-label">
              Enter Amount to Move
            </label>
            <input
              type="number"
              placeholder="Enter Amount to Move in Main Wallet"
              value={amountToMove}
              max={walletAmt?.aeps?.balance || 0}
              onChange={(e) => {
                let val = Number(e.target.value);
                if (val < 0) val = 0;
                if (val > walletAmt?.aeps?.balance) val = walletAmt?.aeps?.balance;
                setAmountToMove(val);
              }}
              className="ds-input text-sm"
            />
          </div>

          <div>
            <label className="ds-label">
              Remarks <span className="text-[var(--error-color)]">*</span>
            </label>
            <textarea
              placeholder="Enter Your Remarks..."
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="ds-input text-sm h-16 resize-none"
            ></textarea>
          </div>

          <div className="ds-form-actions">
            <button
              type="submit"
              disabled={loading}
              className="ds-btn ds-btn-primary"
            >
              {loading ? "Transferring..." : "Transfer"}
            </button>
            <button
              type="button"
              onClick={close}
              className="ds-btn ds-btn-secondary"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AepsToMain;
